import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import AuctionForm from "../../../../commonComponents/AuctionForm";
import getEventDetail from "../../../../../api/getEventDetail";
import getCountries from "../../../../../api/getContriesAPI";
import getStateAPI from "../../../../../api/getStateAPI";
import { eventUpdateAPI } from "../../../../../api/adminAPI/eventUpdateAPI";
import Loader from "../../../../../common/Loader";
import useStyles from "../../../Create/CreateEvent/createEvent.styles";
import "react-toastify/dist/ReactToastify.css";

function EditEvent({ AuctionTable, EditTabEvent, eventId }) {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [eventData, setEventData] = useState({});
  const [eventInfo, setEventInfo] = useState({
    auctionTitle: "",
    referenceNumber: "",
    description: "",
    eventType: "",
    testProject: "false",
    streetOne: "",
    streetTwo: "",
    country: "",
    province: "",
    bidType: "",
    city: "",
    postalCode: "",
    eventImage: "",
    auctionCatalogue: "",
    bidStartDateTime: "",
    visibility: "",
    ownerOfLots: "",
  });

  const [countriesList, setCountriesList] = useState({
    apiState: "loading",
    list: [],
  });

  const [stateList, setStateList] = useState({
    apiState: "loading",
    list: [],
  });

  const fetchCountries = useCallback(async () => {
    try {
      const { data } = await getCountries();
      if (data) {
        setCountriesList({ apiState: "success", list: data });
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  }, []);

  const fetchStateData = useCallback(async (countryId) => {
    try {
      const { data } = await getStateAPI(countryId);
      if (data) {
        setStateList({ apiState: "success", list: data });
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  }, []);

  const fetchEventDetails = useCallback(async () => {
    try {
      const payload = { auctionId: eventId };
      const { data } = await getEventDetail(payload);
      if (data) {
        setEventData(data);
        setEventInfo({
          auctionTitle: data.auctionTitle || "",
          referenceNumber: data.referenceNumber || "",
          description: data.description || "",
          eventType: data.eventType || "",
          testProject: String(data.testProject),
          streetOne: data.streetOne || "",
          streetTwo: data.streetTwo || "",
          country: data.countryId || "",
          province: data.provinceId || "",
          city: data.city || "",
          bidType: data.bidType || "",
          postalCode: data.postalCode || "",
          eventImage: data.eventImage || "",
          auctionCatalogue: data.auctionCatalogue || "",
          bidStartDateTime: data.bidStartDateTime || "",
          visibility: data.visibility || "",
          ownerOfLots: data.ownerOfLots || "",
        });
        if (data.countryId) {
          fetchStateData(data.countryId);
        }
      }
    } catch (error) {
      console.error("Error fetching event details:", error);
    }
  }, [eventId, fetchStateData]);

  const fetchInitialData = useCallback(async () => {
    try {
      setIsLoading(true);
      await Promise.all([fetchCountries(), fetchEventDetails()]);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [fetchCountries, fetchEventDetails]);

  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  const handleSubmit = async (event) => {
    try {
      event.preventDefault();
      setIsLoading(true);

      const updateEventInfo = { ...eventInfo };
      delete updateEventInfo.bidStartDateTime;
      updateEventInfo.testProject = updateEventInfo.testProject === "true";

      const { data } = await eventUpdateAPI(updateEventInfo, eventId);
      if (data) {
        toast.success("Event Updated Successfully!");
        setTimeout(() => {
          setIsLoading(false);
          EditTabEvent(eventId);
        }, 1500);
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      if (error.response) {
        toast.error(error.response.data.error || "Something went wrong!");
      } else {
        toast.error("Network Error!");
      }
    }
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <AuctionForm
        mode="edit"
        eventInfo={eventInfo}
        setEventInfo={setEventInfo}
        countriesList={countriesList}
        stateList={stateList}
        fetchStateData={fetchStateData}
        setIsLoading={setIsLoading}
        eventFormat={eventData.eventFormat}
        onSubmit={handleSubmit}
        classes={classes}
        onBack={AuctionTable}
        eventData={eventData}
      />
    </>
  );
}

export default EditEvent;
